import React, { useContext } from 'react';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import { AppConfigContext } from '@providers/AppConfigProvider';
import { Typography } from '@mui/material';

interface MainLogoProps {
  position: 'header' | 'footer';
}

export default function MainLogo({ position = 'header' }: MainLogoProps) {
  const { pathRoot } = useContext(AppConfigContext);
  const pathLogo: string = `${pathRoot}/assets/images/common/logo.svg`;

  return (
    <Box className="flex items-center">
      <Link href="/" className="no-underline rf-hover-element">
        <img src={pathLogo} alt="main-logo" className="h-10 max-sm:h-8" />
      </Link>
      {position !== 'footer' && (
        <Link href="/karte/" className="no-underline rf-hover-element">
          <Box className="ml-6 pb-2 border-b-2 border-b-[#808080] border-solid max-sm:ml-4">
            <Typography className="text-[13px] leading-[14px] font-bold tracking-[0.02em] max-md:tracking-normal text-center text-[#808080] no-underline max-md:text-[11px] max-md:leading-3">
              マンションカルテ
            </Typography>
          </Box>
        </Link>
      )}
    </Box>
  );
}
